
import { t } from '@nextcloud/l10n'
import { computed, inject, ref } from 'vue'
import IconCheck from 'vue-material-design-icons/Check.vue'
import AvatarWrapper from '../AvatarWrapper/AvatarWrapper.vue'
import { ATTENDEE } from '../../constants.ts'
import { getPreloadedUserStatus, getStatusMessage } from '../../utils/userStatus.ts'

export default {
	name: 'SelectableParticipant',

	components: {
		AvatarWrapper,
		IconCheck,
	},

	props: {
		/**
		 * The participant object
		 */
		participant: {
			type: Object,
			required: true,
		},

		checked: {
			type: Array,
			required: true,
		},

		showUserStatus: {
			type: Boolean,
			default: true,
		},
	},

	emits: ['update:checked', 'click-participant'],

	setup(props) {
		// Toggles the bulk selection state of this component
		const isBulkSelection = inject('bulkParticipantsSelection', false)

		// Defines list of locked participants (can not be removed manually
		const lockedParticipants = inject('lockedParticipants', ref([]))

		const isLocked = computed(() => lockedParticipants.value.some((item) => {
			return item.id === props.participant.id && item.source === props.participant.source
		}))

		return {
			isBulkSelection,
			isLocked,
		}
	},

	computed: {
		modelProxy: {
			get() {
				return this.checked
			},

			set(value) {
				if (this.isLocked) {
					return
				}
				this.isBulkSelection
					? this.$emit('update:checked', value)
					: this.$emit('click-participant', this.participant)
			},
		},

		value() {
			return this.participant.attendeeId || this.participant
		},

		actorId() {
			return this.participant.actorId || this.participant.id
		},

		actorType() {
			return this.participant.actorType || this.participant.source
		},

		computedName() {
			return this.participant.displayName || this.participant.label || t('spreed', 'Guest')
		},

		preloadedUserStatus() {
			return getPreloadedUserStatus(this.participant)
		},

		participantStatus() {
			if (this.actorType === ATTENDEE.ACTOR_TYPE.EMAILS) {
				return this.participant.invitedActorId ?? ''
			}
			return this.participant.shareWithDisplayNameUnique
				?? getStatusMessage(this.participant)
		},

		participantAriaLabel() {
			return t('spreed', 'Add participant "{user}"', { user: this.computedName })
		},

		participantNavigationId() {
			if (this.participant.actorType && this.participant.actorId) {
				return this.participant.actorType + '_' + this.participant.actorId
			} else {
				return this.participant.source + '_' + this.participant.id
			}
		},
	},

	methods: {
		t,

		handleEnter(event) {
			if (this.isBulkSelection) {
				event.target.click()
			} else {
				this.$emit('click-participant', this.participant)
			}
		},
	},
}
